import { makeEnum } from "../Base.js"

export class GuideState {
  init() {
    this.steps = []
    this.currentStep = 1;

    this.serFields = [
      'currentStep',
    ]
  }
  
  isStepDone(stepNum) {
    return stepNum < this.currentStep;
  }

  markStepDone(stepNum) {
    // Only advance sequentially for now
    if (stepNum !== this.currentStep) {
      return;
    }
    this.currentStep = stepNum + 1;
  }

  isStepReady(stepNum) {
    if (stepNum < 1 || stepNum > this.steps.length) {
      return false;
    }
    return this.steps[stepNum - 1].isReady();
  }

  allDone() {
    return this.currentStep > this.steps.length;
  }

  reset() {
    this.currentStep = 1;
  }

  getHighlightedPagePath() {
    if (this.currentStep > this.steps.length) {
      return null;
    }
    let step = this.steps[this.currentStep - 1];
    return step.pagePath;
  }
}
makeEnum(GuideState)